import LegerHead from "../../../../../components/categories/siakad/laporan_adab/leger_sync/HomeHead"
export default function Home() {
  
  return (
    <LegerHead />
  );
}